// extracted by mini-css-extract-plugin
export var adviserOverlay = "Figure-module--adviserOverlay--Xfmwd";
export var caption = "Figure-module--caption--u2+Fc";
export var figure = "Figure-module--figure--Rgy-f";
export var gatsbyImageWontMoveWithouThis = "Figure-module--gatsbyImageWontMoveWithouThis--gD9Qz";
export var mainImage = "Figure-module--mainImage--N6g-X";
export var quoteText = "Figure-module--quoteText--fY891";
export var quoteTextVisible = "Figure-module--quoteTextVisible--6dej2";
export var visibleAdviserOverlay = "Figure-module--visibleAdviserOverlay--GEiT+";